import apiClient from './api';

export interface PaymentResponse {
    token: string;
    redirect_url: string;
    /** Our order id, so the client can ask the server to reconcile this payment. */
    order_id: string;
}

export interface PaymentStatus {
    success: boolean;
    status: 'PENDING' | 'SUCCESS' | 'FAILED';
    credits: number | null;
    /** Bonus credits actually granted by a top-up voucher (0 when none). */
    bonusCredits?: number;
    balance: number;
}

export interface PaymentHistory {
    id: string;
    amount: number;
    status: string;
    createdAt: string;
    snapToken?: string;
}

export const paymentService = {
    async createTransaction(amount: number, voucherCode?: string): Promise<PaymentResponse> {
        const response = await apiClient.post<PaymentResponse>('/payment/transaction', voucherCode ? { amount, voucherCode } : { amount });
        return response.data;
    },

    async getHistory(): Promise<PaymentHistory[]> {
        const response = await apiClient.get<PaymentHistory[]>('/payment/history');
        return response.data;
    },

    /**
     * Ask the server to check this payment against Midtrans and credit it if paid.
     *
     * Safe to call repeatedly: the grant happens once, on the PENDING -> SUCCESS
     * transition. Returns null on failure so callers can just skip the row.
     */
    async syncStatus(orderId: string): Promise<PaymentStatus | null> {
        try {
            const response = await apiClient.get<PaymentStatus>(`/payment/status/${encodeURIComponent(orderId)}`);
            return response.data;
        } catch {
            return null;
        }
    },
};
